module.exports = __webpack_public_path__ + "static/img/shipinhao.1bdad46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/shipinhao.jpg
// module id = Q9pn
// module chunks = 1